import SearchIcon from '@mui/icons-material/Search';
import {TextField} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import {styled} from '@mui/material/styles';
import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

import {pxToRem} from '../../utils';
import {convertURLParamsToObject, convertObjectToURLParams} from '../../utils/helper';

const StyledTextField = styled(TextField)(({theme}) => ({
  backgroundColor: theme.palette.white,
  marginRight: pxToRem(16),
  width: '100%',
}));

const DebounceSearchInput = ({placeholderText, value, onChange, debounce = 500, className}) => {
  const history = useHistory();

  const [debouncedValue, setDebouncedValue] = useState(value);

  const [timeoutId, setTimeoutId] = useState(null);

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setDebouncedValue(inputValue);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const newTimeoutId = setTimeout(() => {
      const queryParams = convertURLParamsToObject(window.location.search);
      queryParams.search = inputValue;
      const newQueryParams = convertObjectToURLParams(queryParams);
      history.push({search: newQueryParams});
      onChange(inputValue);
    }, debounce);
    setTimeoutId(newTimeoutId);
  };

  return (
    <StyledTextField
      className={className}
      size="small"
      placeholder={placeholderText}
      value={debouncedValue}
      onChange={handleInputChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default DebounceSearchInput;
